import { injectGlobal } from 'styled-components'

export const injectGlobalStyles = () => injectGlobal` 
  * { box-sizing: border-box; }
  body { margin: 0; }
`

export const theme = {
  breakpoints: [`32em`, `48em`, `64em`, `80em`],
  space: [0, 4, 8, 16, 32, 64, 128],
  fonts: {
    sans: `system-ui, sans-serif`,
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72, 96],
  weights: {
    normal: 400,
    bold: 700,
  },
  colors: {
    black: `#000`,
    white: `#fff`,
    darkgray: `#222020`,
    lightgray: `#f5f5f5`,
  },
  radii: [0, 2, 4],
}



// WEBPACK FOOTER //
// ./src/containers/Layout/styles.js